import React from 'react';
import { Users, Heart, MessageCircle, MapPin } from 'lucide-react';

const Vecinos = () => {
    return (
        <div className="min-h-screen bg-hue-bg font-roboto text-hue-font pb-20">
            {/* Hero Section */}
            <div className="bg-hue-purple text-white pt-32 pb-20 rounded-b-[3rem] px-6 relative overflow-hidden">
                <div className="max-w-4xl mx-auto text-center relative z-10">
                    <h1 className="text-5xl md:text-7xl font-black mb-6 tracking-tight">
                        Vecinos
                    </h1>
                    <p className="text-xl md:text-2xl font-medium opacity-90 max-w-2xl mx-auto">
                        La comunidad es el corazón de Hue. Juntos hacemos que nuestras ciudades sean lugares mejores para vivir.
                    </p>
                </div>

                {/* Decorative Circles */}
                <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>
            </div>

            {/* Content Grid */}
            <div className="max-w-6xl mx-auto px-6 -mt-10">
                <div className="grid md:grid-cols-3 gap-6">

                    {/* Card 1 */}
                    <div className="bg-white rounded-[2rem] p-8 shadow-xl border border-slate-100 flex flex-col items-center text-center hover:transform hover:-translate-y-1 transition duration-300">
                        <div className="w-16 h-16 bg-hue-light-blue rounded-2xl flex items-center justify-center text-hue-purple mb-6">
                            <Users size={32} strokeWidth={2.5} />
                        </div>
                        <h3 className="text-2xl font-bold mb-3">Comunidad Activa</h3>
                        <p className="text-slate-500">
                            Miles de vecinos reportando y validando problemas en tiempo real para mejorar su entorno.
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div className="bg-white rounded-[2rem] p-8 shadow-xl border border-slate-100 flex flex-col items-center text-center hover:transform hover:-translate-y-1 transition duration-300">
                        <div className="w-16 h-16 bg-hue-olive/30 rounded-2xl flex items-center justify-center text-hue-dark-text mb-6">
                            <Heart size={32} strokeWidth={2.5} />
                        </div>
                        <h3 className="text-2xl font-bold mb-3">Impacto Real</h3>
                        <p className="text-slate-500">
                            Cada reporte cuenta. Tu participación directa ayuda a priorizar y resolver problemas locales.
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div className="bg-white rounded-[2rem] p-8 shadow-xl border border-slate-100 flex flex-col items-center text-center hover:transform hover:-translate-y-1 transition duration-300">
                        <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center text-orange-600 mb-6">
                            <MessageCircle size={32} strokeWidth={2.5} />
                        </div>
                        <h3 className="text-2xl font-bold mb-3">Conexión Directa</h3>
                        <p className="text-slate-500">
                            Comunicación transparente entre vecinos y municipios. Sin burocracia, solo soluciones.
                        </p>
                    </div>

                </div>

                {/* Big Feature Card */}
                <div className="mt-6 bg-hue-olive rounded-[2.5rem] p-8 md:p-12 shadow-xl relative overflow-hidden flex flex-col md:flex-row items-center gap-12">
                    <div className="flex-1 relative z-10">
                        <h2 className="text-3xl md:text-5xl font-black text-hue-dark-text mb-6">
                            ¿Eres un líder vecinal?
                        </h2>
                        <p className="text-xl text-hue-dark-text/80 mb-8 font-medium">
                            Únete a nuestro programa de embajadores y ayuda a coordinar mejoras en tu barrio con herramientas exclusivas.
                        </p>
                        <button className="bg-hue-dark-text text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-slate-800 transition shadow-lg">
                            Conviértete en Embajador
                        </button>
                    </div>
                    <div className="flex-1 flex justify-center relative z-10">
                        <div className="bg-white/20 backdrop-blur-md p-8 rounded-[2rem] border border-white/30 rotate-3 hover:rotate-0 transition duration-500">
                            <MapPin size={120} className="text-hue-dark-text" />
                        </div>
                    </div>

                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#403d5c 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
                </div>
            </div>
        </div>
    );
};

export default Vecinos;
